import Blockly from "blockly/core";
import { registerRestrictions } from "../../../../restrictions";

const blockName = "s4d_leaving_guild";

const blockData = {
    "message0": "%{BKY_LEAVING_GUILD}",
    "colour": "#D85E47",
    "output": "Server",
    "tooltip": "",
    "helpUrl": ""
};

Blockly.Blocks[blockName] = {
    init: function() {
        this.jsonInit(blockData);
    }
};

Blockly.JavaScript[blockName] = function() {
    const code = ["s4d.leavingMember.guild", Blockly.JavaScript.ORDER_NONE];
    return code;
};

registerRestrictions(blockName, [
    {
        type: "toplevelparent",
        message: "RES_MUST_BE_IN_ON_MEMBER_LEAVE",
        types: [
            "s4d_on_member_leave"
        ]
    }
]);
